import { useParams } from 'react-router-dom';
import classNames from 'classnames';

import { logError } from 'services/logging/logging';
import { useSupplierPublicInfo } from 'services/repositories/orderForms/orderForms';
import { GenericError } from 'support/helpers/errors/errors';
import { PartnerLogo } from 'components/PartnerLogo/PartnerLogo';

const maxSize = {
  small: 'max-h-10 max-w-[120px] h-auto w-auto',
  large: 'max-h-20 max-w-[120px] h-auto w-auto',
};

export function SupplierLogo({ className, size = 'large' }: { className?: string; size?: 'small' | 'large' }) {
  const params = useParams<{ supplierSlug: string }>();

  const { data, isLoading } = useSupplierPublicInfo({ variables: { supplierSlug: params.supplierSlug } });

  if (!params.supplierSlug) {
    const error = new GenericError('SupplierLogo requires a supplierSlug url param', { params });
    logError(error);
    throw error;
  }

  return (
    <PartnerLogo
      fullSize
      isLoading={isLoading}
      imageUrl={data?.data?.logo_url}
      className={classNames(maxSize[size], isLoading ? 'w-10' : 'w-auto', className)}
      imageClassName={classNames(maxSize[size], 'object-contain')}
    />
  );
}
